<script>
  export let size = 'default'; // 'small', 'default', 'large'
  export let variant = 'default'; // 'default' (light bg), 'dark' (dark bg)
  export let showText = true;

  const sizes = {
    small: { icon: 'w-8 h-8', text: 'text-lg' },
    default: { icon: 'w-10 h-10', text: 'text-xl' },
    large: { icon: 'w-12 h-12', text: 'text-2xl' }
  };

  $: sizeClass = sizes[size] || sizes.default;
</script>

<div class="flex items-center gap-3">
  <!-- Logo Icon - Abstract "L" with signal waves -->
  <div class="{sizeClass.icon} relative">
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
      <!-- Background circle with gradient -->
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:#10b981" />
          <stop offset="100%" style="stop-color:#059669" />
        </linearGradient>
      </defs>
      <rect width="40" height="40" rx="10" fill="url(#logoGradient)"/>

      <!-- Stylized "L" -->
      <path
        d="M12 10V26H24"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
      />

      <!-- Signal waves representing AI/broadcast -->
      <path
        d="M26 14C28 14 30 16 30 20C30 24 28 26 26 26"
        stroke="white"
        stroke-width="2.5"
        stroke-linecap="round"
        fill="none"
        opacity="0.9"
      />
      <path
        d="M29 11C32.5 11 35 15 35 20C35 25 32.5 29 29 29"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        opacity="0.6"
      />
    </svg>
  </div>

  {#if showText}
    <span class="{sizeClass.text} font-bold {variant === 'dark' ? 'text-white' : 'text-slate-900'} tracking-tight">
      LLMTxt<span class="{variant === 'dark' ? 'text-brand-400' : 'text-brand-600'}">Builder</span>
    </span>
  {/if}
</div>
